import { Button, Divider, Flex, Heading, View, Image } from '@adobe/react-spectrum';
import Filters from './Filters';
import PaymentList from './PaymentList/paymentList';
import { useNavigate } from 'react-router-dom';

const TuitionFees = () => {
  const navigate = useNavigate();
  return (
    <View height={'87vh'}>
      <Flex width={'100%'} justifyContent={'space-between'}>
        <Flex gap={'size-150'}>
          <Image width={25} height={25} src={'/images/tuitionFees.png'} alt="File preview" objectFit="contain" />
          <Heading level={3} marginTop={'size-0'}>
            Tuition Fees
          </Heading>
        </Flex>
        <Button variant="cta" onPress={() => navigate('./create')}>
          Pay Fees
        </Button>
      </Flex>
      <Divider size="M" marginTop={'size-100'} />
      <Filters />
      <PaymentList />
    </View>
  );
};

export default TuitionFees;
